<template>
  <div class="RouterFooter">
    <div class="box">
      <div class="box-left">
        <div class="img" @click="back('/')">
          <div><img src="../assets/image/cadalou.png" alt="" /></div>
        </div>
        <!-- <div class="content1" v-if="lan=='en'">
             <img src="@/assets/icon1.png" alt="">

           </div> -->
        <!-- <div class="content1">
          <img src="@/assets/image/容器1.png" alt="" />
           <div
            style="
              width: 2px;
              height: 26px;
              background-color: #fff;
              margin-right: 10px;
            "
          ></div>

          在线客服
        </div> -->
        <div class="content2">
          <img src="@/assets/image/容器 23.png" alt="" />
          <!-- <div
            style="
              width: 2px !important;
              height: 26px;
              background-color: #fff;
              margin-right: 10px;
            "
          ></div> -->
          <div style="width: 100%">
            <p>全国统一客服热线：400-817-1181</p>
            <!-- <p>400-817-1181</p>   -->
          </div>
        </div>
        <div class="content1" style="display: flex">
          <img
            src="@/assets/image/容器 23.png"
            alt=""
            style="margin-right: 8px"
          />
          <span>举报电话：022-83213117</span>
        </div>
        <div class="content1" style="display: flex">
          <img
            src="@/assets/image/容器111.png"
            alt=""
            style="margin-right: 8px"
          />
          <span>投诉邮箱：jykf@caidaqh.com</span>
        </div>
      </div>
      <div class="box-centent">
        <div
          class="item"
          v-for="(menu, index) in list"
          :key="index"
          :class="n == index + 2 ? 'activee' : ''"
        >

        <div v-if="menu.id != 110 && menu.id != 5">
             <h5
            @click="
              backItem('/WineCulture?type=' + menu.id, menu.id, index + 2)
            "
          >

           {{ menu.name === '产品列表' ? '资产管理' : menu.name }}
          </h5>
          <ul>
            <li
              v-for="(item, idx) in menu.children"
              :key="idx"

              @click="
                backChildrenNew(
                  '/WineCulture?type=' + menu.id + '&id=' + item.id,
                  item.id,
                  index + 2
                )
              "
            >

				 {{ item.name }}


            </li>
          </ul>
        </div>
        </div>
      </div>
      <div class="box-right">
        <div class="img-box">
          <div class="er-img">
            <div>
              <img src="../assets/image/weixin.jpg" alt="" />
            </div>
          </div>
          <div class="img-title" style="display: flex">
            <div>官方微信公众号</div>
          </div>
        </div>
		<div class="newfootimg">
				<div @click="clickht">
					<img src="../assets/image/foot.png" alt="" />
				</div>
		</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="Footer">

      <div class="ICP" @click="GoICP()">
        Copyright ©财达期货有限公司 津ICP备14000958号-1
      </div>
      <img class="img11111" src="../assets/image/gongan-T.png" alt="" />
      <div class="ICP">津公网安备12010102000047号</div>
	  <img class="img2222" src="../assets/image/ipv666.png" alt="" />
	  <div class="ICP">本网站已支持IPV6访问</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lan: String,
    n: Number,
    menuList: Array,
  },
  data() {
    return {
      showswiper: false,
      showswiper1: false,
      detail: "",
      list: [],
      token: 0,
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.seo();
    // Vue.filter("removeGoodsItems", function (menuList) {
    //   return menuList.filter(function (item) {
    //     // 返回name不为"商品"的元素
    //     return item.name !== "商品" && item.name !== "营业网点" && item.name !== "信息公示";
    //   });
    // });
  },
  watch: {
    menuList() {
      this.list = this.menuList.filter(
        (item) =>
          (item.name != "商品" &&
            item.name != "营业网点" &&
            item.name != "信息公示") ||
          !item.children
      );
    },
  },
  methods: {
    callPhone(phoneNumber) {
      this.$refs.tels.href = `tel://` + phoneNumber;
      this.$refs.tels.click();
    },

    seo() {
      this.$http.post("/index/seo/list", {}).then((res) => {
        if (res.data.code == 0) {
          this.detail = res.data.data;
          console.log(res.data.data);
        }
      });
    },
    backItem(i, id, idx) {
      this.n = idx;
      if (!this.token && id == 5) {
        this.$router.push("/Login");
      } else {
        this.$router.push(i);
      }
      this.drawer = false;
    },
    backChildrenNew(i, id, idx) {
      this.n = idx;
      if (
        (!this.token && id == 42) ||
        (!this.token && id == 43) ||
        (!this.token && id == 44) ||
        (!this.token && id == 45)
      ) {
        this.$router.push("/Login");
      } else {
        this.$router.push(i);
      }
      this.drawer = false;
    },
    back1() {
      this.showswiper = true;
    },
    back2() {
      this.showswiper1 = true;
    },
    back(i, idx) {
      this.n = idx;
      this.$router.push(i);
    },
    GoICP() {
      window.open("https://beian.miit.gov.cn/");
    },
	clickht(){
		window.open("https://www.12377.cn/");
	},
    verifyLogin() {
      // let check = sessionStorage.getItem('token')
      // console.log(check)
      // return check
    },
  },
};
</script>

<style lang="scss" scoped>
.RouterFooter {
  width: 100%;
  // height: 400px;
  margin: 0 auto;
  background: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 300px) {
    padding: 50px 0;
  }
  .box {
    max-width: 1400px;
    width: 100%;
    color: white;
    margin: 62px 334px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    // height: 333px;
    @media (max-width: 1366px) {
      width: 950px;
    }
    @media (max-width: 1200px) {
      width: 100%;
    }
    @media (max-width: 950px) {
      width: 700px;
    }
    @media (max-width: 800px) {
      width: 350px;
      margin: 20px 334px 0;
    }
    @media (max-width: 500px) {
      width: 90%;
    }
    @media (max-width: 300px) {
      width: 85%;
      margin: 0;
    }

    .box-left {
      width: 300px;
      // height: 185px;
      @media (max-width: 1200px) {
        margin-left: auto;
      }
      @media (max-width: 920px) {
        margin: 0 auto;
      }
      @media (max-width: 800px) {
        margin: 0 auto;
        width: 300px;
      }
      @media (max-width: 800px) {
        margin: 0 auto;
        // width: 100%;
      }
      .img:hover img {
        transform: translateY(-10px);
      }
      .img {
        width: 200px;
        height: 60px;
        cursor: pointer;
        img {
          transition: transform 0.5s ease;
          max-width: 100%;
        }
      }
      .content1:hover img {
        transform: translateY(-6px);
      }
      .content1 {
        display: flex;
        height: 28px;
        line-height: 24px;
        margin-top: 10px;
        font-size: 16px;
        cursor: pointer;
@media (max-width: 300px) {
          margin-top: 30px;
        }
        font-family: Source Han Sans SC-ExtraLight, Source Han Sans SC !important;
        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
          transition: transform 0.5s ease;
          max-width: 100%;
        }
      }
      .content2:hover img {
        transform: translateY(-6px);
      }
      .content2 {
        display: -webkit-box;
        // width: 182px;
        height: 28px;
        line-height: 24px;
        font-weight: 400;
        margin-top: 10px;
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN !important;
        cursor: pointer;
        @media (max-width: 300px) {
          margin-top: 30px;
        }
        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
          transition: transform 0.5s ease;
          max-width: 100%;
          // @media (max-width: 1199px) {
          //   width: 20px;
          //   height: 20px;
          //   margin-top: 5px;
          // }
        }
      }
      .content2 p {
        word-break: break-all;
        margin: 0;
      }
      .content2 p:nth-of-type(2) {
        // display: flex;
        width: 160px;
        height: 20px;
        line-height: 14px;
        font-weight: 400;
        margin-top: 7px;
        font-size: 20px !important;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN-Bold !important;
        font-weight: normal;
      }
    }
    .box-centent {
      // width: 650px;
      margin: 0 auto;
      @media (max-width: 1366px) {
        // width: 600px;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
      }
      @media (max-width: 1200px) {
        width: 600px;
        margin-right: auto;
        display: flex;
        flex-wrap: wrap;
      }
      @media (max-width: 920px) {
        margin: 0 auto;
      }
      @media (max-width: 800px) {
        display: none;
      }
      .item {
        // width: 75px;
        width: 85px;
        float: left;
        margin-left: 40px;
        // opacity: 0.6;
        color: #fff;
        font-size: 14px;

        @media (max-width: 1200px) {
          margin-left: 30px;
        }

        h5:hover {
          font-weight: bold;
        }
        h5 {
          font-family: Microsoft YaHei, Microsoft YaHei !important;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 17px;
          cursor: pointer;
          transition: font-weight 0.5s;
        }
      }
      .item:first-child {
        margin-left: 0;
      }
      .item li:hover {
        color: #fff;
        // opacity: 1;
      }
      .item li {
        font-family: Microsoft YaHei, Microsoft YaHei !important;
        list-style: none;
        margin: 10px 0;
        padding: 0;
        color: rgb(164, 164, 164);
        // opacity: 0.6;
        cursor: pointer;
        transition: color 0.5s;
      }
      .item ul {
        margin: 0;
        padding: 0;
      }
    }
    .box-right {
      display: flex;
      align-items: center;
	  flex-direction: column;
      width: 120px;
      height: 285px;

      @media (max-width: 1440px) {
        // margin: 30px auto;
        height: 140px;
      }
      @media (max-width: 500px) {
        // margin: 30px auto;
        width: 120px;
        margin: 10px auto;
      }

	  .newfootimg{
		  margin-top: 20px;
		  cursor: pointer;
		  transition: transform 0.5s ease;
		  @media (max-width:800px) {
		  	margin-bottom: 100px;
		  }
		  img{
			  height: 40px;
			  width: auto;
		  }
	  }

	  .newfootimg:hover{
		  transform: translateY(-6px);
	  }

      .img-box {
        width: 100%;
        height: 138px;
        @media (max-width: 300px) {
          height: 115px;
          justify-content: center;
        }
        .er-img:hover img {
          transform: translateY(-6px);
        }
        .er-img {
          width: 119px;
          margin: 0 auto;
          // height: 200px;
          // margin-right: 55px;
          cursor: pointer;
          @media (max-width: 300px) {
            // margin-right: 10px;
          }
          img {
            width: 119px !important;
            height: 119px !important;
            transition: transform 0.5s ease;
            max-width: 100%;
            @media (max-width: 300px) {
              width: 100px;
              height: 100px;
            }
          }
        }
        .img-title {
          width: 100%;
          height: 16px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN-Medium !important;
          font-weight: normal;
          font-size: 16px;
          color: #ffffff;
          line-height: 14px;
          justify-content: center;
          cursor: pointer;
          @media (max-width: 500px) {
            width: 100%;
            margin: 0 auto;
            flex-wrap: wrap;
            font-size: 13px;
            justify-content: center;
          }
        }
      }

      // .img-title div:first-child {
      //   // margin-right: 20px;
      // }
      // .img-title div:last-child {
      //   // margin-left: 5px;
      //   @media (max-width: 300px) {
      //     margin-left: 0;
      //   }
      // }
      .content1:hover img {
        transform: translateY(-6px);
      }
      .content1 {
        margin-top: 19px;
        @media (max-width: 1199px) {
          margin-top: 10px;
        }
        // justify-content: center;
        text-align: center;
        cursor: pointer;
        img {
          transition: transform 0.5s ease;
          max-width: 100%;
          width: 35px;
          height: 35px;
        }
        span {
          text-align: center;
          @media (max-width: 800px) {
            width: 100%;
          }
        }
      }
    }
  }
  .line {
    width: 100%;
    height: 1px;
    margin-top: 10px;
    margin: 5px 0 21px;
    // display: flex;
    background-color: #4a4b4e;
    justify-content: center;
	@media (max-width: 800px) {

	  margin-top: 70px;
	}
  }
  .Footer {
    width: 1000px;
    height: 10px;
    display: flex;
    @media (max-width: 800px) {
      width: 350px;
      height: 60px;
      flex-wrap: wrap;

    }
    @media (max-width: 500px) {
      width: 80%;
      // height: 60px;
      flex-wrap: wrap;
    }
    @media (max-width: 300px) {
      width: 100%;
      margin: 0 auto;
      // height: 60px;
      flex-wrap: wrap;
    }

    margin-bottom: 27px;

    .img11111 {
      width: 20px;
      height: 20px;
      margin-left: 16px;
      margin-right: 8px;
      cursor: pointer;
    }

	.img2222 {

      height: 18px;
      margin-left: 16px;
      margin-right: 8px;
      cursor: pointer;
    }

    .ICP {
      font-family: SourceHanSansCN-Light, SourceHanSansCN-Light !important;
      font-size: 14px;
      color: #939393;
      // opacity: 0.7;
      cursor: pointer;
      transition: color 0.5s ease;
      text-align: center;
      @media (max-width: 800px) {
        margin: 0 auto;
      }
      @media (max-width: 300px) {
        text-align: center;
      }
    }
    .ICP:last-child {
      margin: 0;
    }
    .ICP:hover {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RouterFooter.vue